import Reset from './reset.svg';
import Setting from './setting.svg';

export const SettingsIcons = {
  Reset,
  Setting,
};
